export const APPOINTMENTS_ROUTE = 'appointments';
export const APPOINTMENTS_MASTER_ROUTE = `/${APPOINTMENTS_ROUTE}`;
export const BILLING_ROUTE = 'billing';
export const BILLING_MASTER_ROUTE = `/${BILLING_ROUTE}`;
export const ACCOUNT_BLOCKED_ROUTE = 'verify-account';
export const ACCOUNT_BLOCKED_MASTER_ROUTE = `/${ACCOUNT_BLOCKED_ROUTE}`;
export const GLOBAL_SEARCH_ROUTE = 'global-search';
export const HOME_ROUTE = 'home';
export const HOME_MASTER_ROUTE = `/${HOME_ROUTE}`;
export const INVOICES_ROUTE = 'invoices';
export const INVOICES_MASTER_ROUTE = `/${INVOICES_ROUTE}`;
export const ESTIMATES_ROUTE = 'estimates';
export const ESTIMATES_MASTER_ROUTE = `/${ESTIMATES_ROUTE}`;
export const PURCHASE_ORDERS_ROUTE = 'purchase-orders';
export const PURCHASE_ORDERS_MASTER_ROUTE = `/${PURCHASE_ORDERS_ROUTE}`;
export const CREDIT_MEMOS_ROUTE = 'credit-memos';
export const CREDIT_MEMOS_MASTER_ROUTE = `/${CREDIT_MEMOS_ROUTE}`;
export const CLIENTS_ROUTE = 'clients';
export const CLIENTS_MASTER_ROUTE = `/${CLIENTS_ROUTE}`;
export const EXPENSES_ROUTE = 'expenses';
export const EXPENSES_MASTER_ROUTE = `/${EXPENSES_ROUTE}`;
export const ITEMS_ROUTE = 'items';
export const ITEMS_MASTER_ROUTE = `/${ITEMS_ROUTE}`;
export const TRACKED_TIMES_ROUTE = 'tracked-times';
export const TRACKED_TIMES_MASTER_ROUTE = `/${TRACKED_TIMES_ROUTE}`;
export const REPORTS_ROUTE = 'reports';
export const REPORTS_MASTER_ROUTE = `/${REPORTS_ROUTE}`;
export const INSTANT_WEBSITE_ROUTE = 'instant-website';
export const INSTANT_WEBSITE_MASTER_ROUTE = `/${INSTANT_WEBSITE_ROUTE}`;
export const REFER_A_FRIEND_ROUTE = 'refer-a-friend';
export const REFER_A_FRIEND_MASTER_ROUTE = `/${REFER_A_FRIEND_ROUTE}`;
export const SETTINGS_ROUTE = 'settings';
export const SETTINGS_V2_ROUTE = 'settings';
export const SETTINGS_MASTER_ROUTE = `/${SETTINGS_ROUTE}`;
export const SETTINGS_V2_MASTER_ROUTE = `/${SETTINGS_V2_ROUTE}`;
export const HELP_ROUTE = 'help';
export const HELP_MASTER_ROUTE = `/${HELP_ROUTE}`;
export const ONBOARDING_ROUTE = 'onboarding';
export const ONBOARDING_MASTER_ROUTE = `/${ONBOARDING_ROUTE}`;
export const PAYWALL_ROUTE = 'purchase';
export const PAYWALL_MASTER_ROUTE = `/${PAYWALL_ROUTE}`;
